import { stimulusApp } from './application.js'
import ScaConsentCallbackController from './sca_consent_callback_controller.js'
import GtmEventController from './gtm_event_controller.js'
import SmartInvestAnnouncementController from './smart_invest_announcement_controller'
import FormCompletenessController from './form_completeness_controller'
import ProfileCompletionController from './profile_completion_controller'
import CheckboxFilterController from './checkbox_filter_controller'

// Register controllers
stimulusApp.register('gtm-event', GtmEventController);
stimulusApp.register('sca-consent-callback', ScaConsentCallbackController);
stimulusApp.register('smart-invest-announcement', SmartInvestAnnouncementController);
stimulusApp.register('form-completeness', FormCompletenessController);
stimulusApp.register('profile-completion', ProfileCompletionController);
stimulusApp.register('checkbox-filter', CheckboxFilterController);
